import { roundRupees } from './money';

export const WHOLESALE_MIN_TOTAL_QTY = 14;

export function getTotalCartQty(cart) {
  return cart.reduce((sum, item) => sum + (item.quantity || 0), 0);
}

/** Wholesale pricing applies only when mode is wholesale and total cart qty meets threshold. */
export function resolveShopOrderType(cart, customerMode = 'retail') {
  if (customerMode === 'wholesale' && getTotalCartQty(cart) >= WHOLESALE_MIN_TOTAL_QTY) {
    return 'wholesale';
  }
  return 'retail';
}

export function isWholesalePricingEligible(cart, customerMode = 'retail') {
  return customerMode === 'wholesale' && getTotalCartQty(cart) >= WHOLESALE_MIN_TOTAL_QTY;
}

export function getShopLineUnitPrice(item, orderType) {
  if (orderType === 'wholesale') {
    return roundRupees(item.wholesalePrice ?? item.price);
  }
  return roundRupees(item.retailPrice ?? item.price);
}

export function getShopDisplayUnitPrice(item, customerMode = 'retail') {
  return getShopLineUnitPrice(item, customerMode === 'wholesale' ? 'wholesale' : 'retail');
}

export function calculateShopCartTotal(cart, orderType = 'retail') {
  return roundRupees(
    cart.reduce(
      (sum, item) => sum + roundRupees(getShopLineUnitPrice(item, orderType) * item.quantity),
      0
    )
  );
}

export function getShopMinimumAdvance(totalAmount) {
  return roundRupees(Math.ceil(roundRupees(totalAmount) * 0.4));
}

export function filterShopInventoryForMode(items, customerMode = 'retail') {
  if (customerMode !== 'wholesale') return items;
  return items.filter((item) => !item.retailOnly);
}

export function showsRetailOnlyWholesaleHint() {
  return false;
}
